import React, { useEffect } from "react";
import AboutBanner from "../components/About/AboutBanner";
import AboutVision from "../components/About/AboutVision";
import AboutPillars from "../components/About/AboutPillars";
import AboutWhyUs from "../components/About/AboutWhyUs";
// import AboutTeam from "../components/About/AboutTeam";
import HomeContact from "../components/Home/HomeContact";
import AboutLoaction from "../components/About/AboutLoaction";
import AboutTeam2 from "../components/About/AboutTeam2";
// import AboutMap from "../components/About/AboutMap";

const AboutPage = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <>
      <title>About Truviq System</title>
      <AboutBanner />
      <AboutVision />
      <AboutPillars />
      <AboutWhyUs />
      {/* <AboutTeam /> */}
      <AboutTeam2 />
      <AboutLoaction />
      <HomeContact />
      {/* <AboutMap /> */}
    </>
  );
};

export default AboutPage;
